import keyNaveService from '@/services/key-nave.service';

const initialState = {
    status: {
        listLicensesComplete: false,
        getLicenseComplete: false,
        createLicenseComplete: false,
        updateLicenseComplete: false,
        deleteLicenseComplete: false,
    },
    licenses: [],
    license: {},
    createLicense: {},
    updateLicense: {},
    deleteLicense: {}
};

export const keyNaveModule = {
    namespaced: true,
    state: initialState,
    actions: {
        clearLicenses({ commit }) {
            commit('clearLicenses');
        },
        listLicenses({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                keyNaveService.listLicenses(payload.page, payload.limit, payload.filter)
                    .then(licenses => {
                        commit('populateLicenses', licenses);
                        resolve(licenses);
                    })
                    .catch(error => {
                        commit('clearLicenses');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearLicense({ commit }) {
            commit('clearLicense');
        },
        getLicense({ dispatch, commit }, license) {
            return new Promise((resolve, reject) => {
                commit('clearLicense');
                keyNaveService.getLicense(license)
                    .then(license => {
                        commit('populateLicense', license);
                        resolve(license);
                    })
                    .catch(error => {
                        commit('clearLicense');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearCreateLicense({ commit }) {
            commit('clearCreateLicense');
        },
        createLicense({ dispatch, commit }, payload) {
            commit('clearCreateLicense');
            return new Promise((resolve, reject) => {
                keyNaveService.createLicense(payload.amount, payload.party, payload.order, payload.product, payload.purchaseDate)
                    .then(createLicense => {
                        commit('populateCreateLicense', createLicense);
                        resolve(createLicense);
                    })
                    .catch(error => {
                        commit('clearCreateLicense');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearUpdateLicense({ commit }) {
            commit('clearUpdateLicense');
        },
        updateLicense({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('clearUpdateLicense');
                keyNaveService.updateLicense(payload.license, payload.status)
                    .then(updateLicense => {
                        commit('populateUpdateLicense', updateLicense);
                        resolve(updateLicense);
                    })
                    .catch(error => {
                        commit('clearUpdateLicense');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearDeleteLicense({ commit }) {
            commit('clearDeleteLicense');
        },
        deleteLicense({ dispatch, commit }, license) {
            return new Promise((resolve, reject) => {
                commit('clearDeleteLicense');
                keyNaveService.deleteLicense(license)
                    .then(deleteLicense => {
                        commit('populateDeleteLicense', deleteLicense);
                        resolve(deleteLicense);
                    })
                    .catch(error => {
                        commit('clearDeleteLicense');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
    },
    mutations: {
        clearLicenses(state) {
            state.status.listLicensesComplete = false;
            state.licenses = [];
        },
        populateLicenses(state, licenses) {
            state.status.listLicensesComplete = true;
            state.licenses = licenses;
        },
        clearLicense(state) {
            state.status.getLicenseComplete = false;
            state.license = [];
        },
        populateLicense(state, license) {
            state.status.getLicenseComplete = true;
            state.license = license;
        },
        clearCreateLicense(state) {
            state.status.createLicenseComplete = false;
            state.createLicense = {};
        },
        populateCreateLicense(state, createLicense) {
            state.status.listDocumentsComplete = true;
            state.createLicense = createLicense;
        },
        clearUpdateLicense(state) {
            state.status.updateLicenseComplete = false;
            state.updateLicense = {};
        },
        populateUpdateLicense(state, updateLicense) {
            state.status.updateLicenseComplete = true;
            state.updateLicense = updateLicense;
        },
        clearDeleteLicense(state) {
            state.status.deleteLicenseComplete = false;
            state.deleteLicense = {};
        },
        populateDeleteLicense(state, deleteLicense) {
            state.status.deleteLicenseComplete = true;
            state.deleteLicense = deleteLicense;
        }
    }
};
